import * as _ from 'lodash';
import * as moment from 'moment';
import {purposeMapping} from "../config/constants";
import {useEffect, useState} from 'react';

export function humanFileSize(bytes, si=true) {
  var thresh = si ? 1000 : 1024;
  if(Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }
  var units = si
    ? ['kB','MB','GB','TB','PB','EB','ZB','YB']
    : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
  var u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while(Math.abs(bytes) >= thresh && u < units.length - 1);
  return bytes.toFixed(1)+' '+units[u];
}

export function emailIsValid (email) {
  return /\S+@\S+\.\S+/.test(email)
}

export function isFormValid(errors) {
  // check if any of the fields have an error
  return !Object.keys(errors).some((field) => errors[field])
}


export function updateVaultDetails(vault) {
  vault['lastUpdated'] = moment(vault.updated).format('MM-DD-YYYY');
  vault['purposeDisplay'] = purposeMapping[vault['purpose']];
  if (_.includes(['UNLOCKED', 'PENDING'], vault.status)) {

    vault.approvals = _.sumBy(vault.access_request.guardians, (guardian) => guardian['status'] === 'APPROVED' ? 1 : 0);
    vault.rejections = _.sumBy(vault.access_request.guardians, (guardian) => guardian['status'] === 'REJECTED' ? 1 : 0);
    vault.accessRequestedAt = moment(vault.access_request.requested_at).format('LLL');
    vault.accessRequestCompletedAt = moment(vault.access_request.completed_at).format('LLL');
    vault.accessDelayed = vault.unlocked_at && moment(vault.unlocked_at) > moment();
  }

  return vault
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}